module.exports = __webpack_public_path__ + "static/media/SmartManagement_EN.6bb018f7.png";